import React, { useEffect } from "react";
import { Button, Form, FormInstance } from "antd";
import { map } from "lodash";
import { DropdownInput } from "components";
import {
  DOWNVOTE_TURN_OPTIONS,
  FEEDBACK_TYPE_OPTIONS,
  FLUENCY_LEVEL_OPTIONS,
  POST_ACTION_COLOR,
  POST_ACTION_OPTIONS,
} from "./constants";
import { UserFeedbackAdvancedSearch } from "./useUserFeedbackStore";
import styles from "./UserFeedbackList.module.scss";

interface Props {
  form: FormInstance<UserFeedbackAdvancedSearch>;
  initialValues: UserFeedbackAdvancedSearch;
  visible: boolean;
  onFinish: (values: UserFeedbackAdvancedSearch) => void;
  onCancel: () => void;
}

const DROPDOWN_WIDTH = 260;

const POST_ACTION_DROPDOWN_OPTIONS = map(POST_ACTION_OPTIONS, ({ label, value }) => ({
  value,
  label: (
    <span className={styles.postActionLabel}>
      {label}
      <i className={styles.postActionDot} style={{ backgroundColor: POST_ACTION_COLOR[value] }} />
    </span>
  ),
}));

function AdvancedSearch({ form, initialValues, visible, onFinish, onCancel }: Props) {
  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, initialValues, form]);

  return (
    <Form<UserFeedbackAdvancedSearch> form={form} initialValues={initialValues} onFinish={onFinish}>
      <div className={styles.advancedSearchForm}>
        <Form.Item label="Feedback type:" name="types">
          <DropdownInput width={DROPDOWN_WIDTH} options={FEEDBACK_TYPE_OPTIONS} placeholder="All types" />
        </Form.Item>
        <Form.Item label="Downvote at:" name="downvoteTurns">
          <DropdownInput width={DROPDOWN_WIDTH} options={DOWNVOTE_TURN_OPTIONS} placeholder="All turns" />
        </Form.Item>
        <Form.Item label="Post-Action:" name="postActions">
          <DropdownInput width={DROPDOWN_WIDTH} options={POST_ACTION_DROPDOWN_OPTIONS} placeholder="All actions" />
        </Form.Item>
        <Form.Item label="Fluency level:" name="fluencyLevels">
          <DropdownInput width={DROPDOWN_WIDTH} options={FLUENCY_LEVEL_OPTIONS} placeholder="All levels" />
        </Form.Item>
      </div>

      <div className={styles.advancedSearchButtons}>
        <Button type="default" shape="round" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" shape="round" htmlType="submit">
          Search
        </Button>
      </div>
    </Form>
  );
}

export default AdvancedSearch;
